import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { useEffect } from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'
import { modalCreators } from '@/store/ducks/modal'

dayjs.extend(utc)
dayjs.locale('pt-br')

// Função para encontrar a data mais recente que satisfaça a regra
const findLatestOnboardingDate = (
	onboarding_all: Array<{
		nivel_onboarding: number
		updatedAt: string
	}>
) => {
	if (!onboarding_all || onboarding_all.length === 0) return null

	const filteredItems = onboarding_all.filter(
		(item) => item.nivel_onboarding === 0 || item.nivel_onboarding >= 4
	)

	if (filteredItems.length === 0) return null

	// Reduzimos os itens filtrados para encontrar o mais recente
	const latest = filteredItems.reduce(
		(
			latest: {
				nivel_onboarding: number
				updatedAt: string
			},
			current: {
				nivel_onboarding: number
				updatedAt: string
			}
		) =>
			dayjs(current.updatedAt).isAfter(dayjs(latest.updatedAt))
				? current
				: latest
	)

	return latest.updatedAt
}

export const useShowWhatsappModal = () => {
	const {
		auth: { user },
	} = useAppSelector((state) => state)
	const dispatch = useAppDispatch()

	useEffect(() => {
		if (!user?.onboarding_all) return

		const latestUpdatedAt = findLatestOnboardingDate(user.onboarding_all)

		if (!latestUpdatedAt) return

		const endDate = dayjs(latestUpdatedAt).endOf('day')
		const isPast = dayjs().endOf('day').isAfter(endDate)

		// Verificar se o telefone não está cadastrado e a data é no passado
		if (!user?.telephone && isPast) {
			dispatch(
				modalCreators.openModal({
					name: 'whatsappModal',
					disabledOnClose: true,
				})
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.onboarding_all, user?.telephone])
}
